import Button from "components/general/buttonv2";
import {
  StyledContainer,
  StyledTitle,
  StyledTitleBelow,
  StyledWrapper,
} from "components/home/styling";
import { pricingData } from "data/homeData";
import { DISCORD_LINK, downloadButtonText, downloadsDisabled } from "data/variables";
import styled from "styled-components";

const StyledWrapperSpecified = styled(StyledWrapper)`
  margin-top: 6rem;
  padding-top: 4rem;
  position: relative;
  padding-bottom: 4rem;
  @media screen and (max-width: 768px) {
    margin-top: 0;
  }
`;
const StyledButtonGroup = styled.div`
  display: flex;
  margin-top: 2rem;
  > * {
    margin: 0 0.5rem;
  }
  @media screen and (max-width: 768px) {
    margin-top: 0;
    flex-direction: column;
    width: 100%;
    > * {
      margin: 0 0 1rem 0;
    }
  }
`;
const Pricing = () => {
  return (
    <StyledWrapperSpecified>
      <StyledContainer>
        <StyledTitle>{pricingData.title}</StyledTitle>
        <StyledTitleBelow>{pricingData.subtitle}</StyledTitleBelow>
        <StyledButtonGroup>
          <Button
            disabled={downloadsDisabled}
            alignSelf="center"
            to="/download"
            buttonPrimary={true}
          >
            {downloadButtonText}
          </Button>
          <Button alignSelf="center" href={DISCORD_LINK}>
            Join Redact Discord
          </Button>
        </StyledButtonGroup>
      </StyledContainer>
    </StyledWrapperSpecified>
  );
};

export default Pricing;
